var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.84229 16.25L13.083 12L8.84229 7.75001L10.1478 6.44446L15.7034 12L10.1478 17.5556L8.84229 16.25Z"}));
}

ChevronRight.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
